import { GSection } from 'components/basic-blocks'
import { RulesList } from './components/rules-list'
import { RulesPanelProps } from './types'
import { RulesSettings } from './components/rules-settings'
export const RulesPanel = ({
	level,
	targetId,
	targetName,
	platform,
	activeTab
}: RulesPanelProps) => {
	return (
		<div className="w-full flex flex-col gap-3">
			{(level === 'ad-account' || level === 'campaign') && (
				<GSection contentClassName="h-full w-full" containerClassName="!mb-0">
					<RulesSettings
						level={level}
						targetId={targetId}
						targetName={targetName}
						platform={platform}
					/>
				</GSection>
			)}
			<GSection containerClassName="h-full w-full !mb-0">
				<RulesList
					level={level}
					targetId={targetId}
					targetName={targetName}
					platform={platform}
					activeTab={activeTab}
				/>
			</GSection>
		</div>
	)
}
